<template>
  <div class="editDictData">
    <!--新增-->
    <el-dialog
      :title="$t('dict.editDataTitle') + dict.dictName + $t('dict.insertDataTitle2')"
      :visible.sync="dialogEdit"
      :close-on-click-modal="false"
      width="400px"
    >
      <el-form
        label-width="auto"
        :rules="rules"
        :model="addList"
        ref="addList"
        :label-position="'right'"
      >
        <el-form-item :label="$t('dict.dataName')" prop="dataName">
          <el-input
            v-model="addList.dataName"
            clearable
            :placeholder="$t('dict.dataNamePlaceholder')"
          ></el-input>
        </el-form-item>
        <el-form-item :label="$t('dict.dataValue')" prop="dataValue">
          <el-input
            v-model="addList.dataValue"
            clearable
            :placeholder="$t('dict.dataValuePlaceholder')"
          ></el-input>
        </el-form-item>
        <el-form-item :label="$t('dict.remark')" prop="remark">
          <el-input
            type="textarea"
            v-model="addList.remark"
            :rows="2"
            clearable
            :placeholder="$t('dict.remarkPlaceholder')"
          ></el-input>
        </el-form-item>
        <el-form-item :label="$t('dict.dataStatus')" prop="dataStatus">
          <el-switch
            v-model="addList.dataStatus"
            :active-value="0"
            :inactive-value="-1"
          ></el-switch>
        </el-form-item>
        <el-form-item :label="$t('dict.sortNo')" prop="sortNo">
          <el-input-number
            v-model="addList.sortNo"
            controls-position="right"
            :min="0"
          ></el-input-number>
        </el-form-item>
        <el-form-item :label="$t('dict.relationDictType')" prop="relationDictType">
          <el-input
            v-model="addList.relationDictType"
            clearable
            :placeholder="$t('dict.relationDictTypePlaceholder')"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" :loading="loading" @click="addSure()">{{
          $t('dialog.confirm')
        }}</el-button>
        <el-button :loading="loading" @click="dialogEdit = false">{{
          $t('dialog.cancel')
        }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
  import API from '../../../api/systemManage/dict.js';
  export default {
    name: 'editDictData',
    data() {
      return {
        loading: false,
        dialogEdit: false,
        dict: '',
        addList: {
          dataCode: '',
          dataName: '',
          dataValue: '',
          dataStatus: 0,
          remark: '',
          sortNo: '',
        },
      };
    },
    computed: {
      rules() {
        // 校验特殊字符
        var specialValidate = (_, value, callback) => {
          // var reg = /(\ud83c[\udf00-\udfff])|(\ud83d[\udc00-\ude4f])|(\ud83d[\ude80-\udeff])/;
          var regEn = /[`!@#$%^&*()_+<>?:"{},.\/;'[\]]/im,
            regCn = /[·！#￥（——）：；“”‘、，|《。》？、【】[\]]/im;
          if (regEn.test(value) || regCn.test(value)) {
            callback(new Error(this.$t('menu.emoticons')));
          } else {
            callback();
          }
        };
        return {
          dataCode: [
            {
              required: true,
              message: this.$t('dict.dataCodeNotEmpty'),
              trigger: 'blur',
            },
            {
              min: 1,
              max: 40,
              message: this.$t('menu.menunameWordNumber'),
              trigger: ['blur', 'change'],
            },
            { validator: specialValidate, trigger: ['blur', 'change'] },
          ],
          dataName: [
            {
              required: true,
              message: this.$t('dict.dataNameNotEmpty'),
              trigger: 'blur',
            },
            {
              min: 1,
              max: 40,
              message: this.$t('menu.menunameWordNumber'),
              trigger: ['blur', 'change'],
            },
            { validator: specialValidate, trigger: ['blur', 'change'] },
          ],
          dataValue: [
            {
              required: true,
              message: this.$t('dict.dataValueNotEmpty'),
              trigger: 'blur',
            },
            {
              min: 1,
              max: 40,
              message: this.$t('menu.menunameWordNumber'),
              trigger: ['blur', 'change'],
            },
            // { validator: specialValidate, trigger: ["blur", "change"] }
          ],
          remark: [
            {
              min: 1,
              max: 400,
              message: this.$t('menu.remarkWordNumber'),
              trigger: ['blur', 'change'],
            },
            // { validator: specialValidate, trigger: ["blur", "change"] }
          ],
          sortNo: [
            {
              required: true,
              message: this.$t('dict.sortNoNotEmpty'),
              trigger: 'blur',
            },
          ],
          relationDictType: [
            {
              min: 1,
              max: 400,
              message: this.$t('menu.remarkWordNumber'),
              trigger: ['blur', 'change'],
            },
            { validator: specialValidate, trigger: ['blur', 'change'] },
          ],
        };
      },
    },
    methods: {
      openDialog(flag, row) {
        if (this.$refs['addList']) {
          this.$refs['addList'].resetFields();
        }
        this.loading = false;
        this.dict = row;
        this.dialogEdit = flag;
        this.getDetail(this.dict.id);
      },
      // 获取详情
      getDetail(id) {
        this.$axios.post(API.GET_DICT_DATA_API, { id: id }).then((res) => {
          if (0 == res.data.code) {
            this.addList = res.data.data;
          } else {
            this.$message({
              showClose: true,
              message: res.data.msg,
              type: 'error',
            });
          }
        });
      },
      //保存
      addSure() {
        this.$refs.addList.validate((valid) => {
          if (valid && !this.loading) {
            this.loading = true;
            this.addList.dictId = this.dict.dictId;
            this.$axios.post(API.UPDATE_DICT_DATA_API, this.addList).then((res) => {
              this.loading = false;
              if (0 != res.data.code) {
                this.$alert(res.data.msg);
              } else {
                this.dialogEdit = false;
                this.$emit('getListData');
                this.$message({
                  showClose: true,
                  message: res.data.msg || this.$t('message.success'),
                  type: 'success',
                });
              }
            });
          } else {
            return false;
          }
        });
      },
    },
  };
</script>
